/**
 * Moves a cut database so that an interruption at any point leaves it on at
 * least one page: the target stores it locally before the source loses it.
 * A crash in between leaves the database on both pages, never on none; the
 * server takes the two pages in either order.
 */
export async function moveDatabaseDurably(input: {
  insert: () => void;
  waitForTargetStored: () => Promise<void>;
  detach: () => void;
}): Promise<void> {
  input.insert();
  await input.waitForTargetStored();
  input.detach();
}
